/* Shared sample photos for all gallery demo pages (Blood Donation set).
   Every demo imports the same PHOTOS so the layouts can be compared fairly. */

import blood1 from '../../images/blood-donation/blood1.webp';
import blood2 from '../../images/blood-donation/blood2.webp';
import blood3 from '../../images/blood-donation/blood3.webp';
import blood4 from '../../images/blood-donation/blood4.webp';
import blood5 from '../../images/blood-donation/blood5.webp';
import blood7 from '../../images/blood-donation/blood7.webp';
import blood8 from '../../images/blood-donation/blood8.webp';
import blood9 from '../../images/blood-donation/blood9.webp';
import blood10 from '../../images/blood-donation/blood10.webp';
import blood12 from '../../images/blood-donation/blood12.webp';

export const PHOTOS = [
    { src: blood1, cap: 'Inside the blood donation bus' },
    { src: blood8, cap: 'Group photo in front of the blood donation bus' },
    { src: blood2, cap: 'Registration and donor support area' },
    { src: blood4, cap: 'Donor resting inside the blood donation bus' },
    { src: blood3, cap: 'Volunteers welcoming donors at the camp' },
    { src: blood10, cap: 'Volunteers standing outside the blood donation bus' },
    { src: blood5, cap: 'Donor seated inside the blood donation bus' },
    { src: blood7, cap: 'Donor giving a thumbs-up during donation' },
    { src: blood12, cap: 'Donors and volunteers posing near the bus' },
    { src: blood9, cap: 'The team after a successful donation drive' },
];
